import { UnknownAction, combineReducers, Reducer } from 'redux';
import hindsighting from './Hindsighting/Hindsighting.reducer';
import reporting from 'src/pages/Reporting/Reporting.slice';
import navigationShell from './NavigationShell/NavigationShell.reducer';
import assortmentBuild from './AssortmentBuild/AssortmentBuild.reducer';
import allocation from './Allocation/Allocation.reducer';
import { cloneDeep, set } from 'lodash';

const pagesCombined = combineReducers({
  hindsighting,
  reporting,
  navigationShell,
  assortmentBuild,
  allocation,
});
export interface PagesSlice extends ReturnType<typeof pagesCombined> {}

export const resetPages = () => {
  return {
    type: 'Pages/resetPages',
  };
};

/**
 * When receiving the action 'Pages/resetPages', we send in undef as the state to be reduced,
 * which causes all the child slices to return their initial state.
 * We use this to clear state of views after leaving them, so that they're in initial state
 * when navigating to them.
 */
const pagesReducer: Reducer<PagesSlice, UnknownAction> = (state: PagesSlice | undefined, action: UnknownAction) => {
  switch (action.type) {
    case 'Pages/resetPages':
      const resetState = cloneDeep(pagesCombined(undefined, action));
      const preservedWorklist = state?.hindsighting.styleColorReview.sharedData.worklist;

      if (preservedWorklist) {
        set(resetState, 'hindsighting.styleColorReview.sharedData.worklist', preservedWorklist || []);
      }
      return resetState;
    default:
      return pagesCombined(state, action);
  }
};

export default pagesReducer;
